import { ConsentBannerAndConsentManagement, FcFooter, FcHeader } from '@common/ui';
import React from 'react';
import { Outlet } from 'react-router-dom';

interface BaseLayoutProps {
  hideLogout?: boolean;
}

export const BaseLayout = ({ hideLogout = false }: BaseLayoutProps) => {

  return (
    <main className={'flex flex-col'}>
      <FcHeader
        hideLogoutButtonAndNavigation={hideLogout}
        navigationItems={[
          { text: 'Tableau de bord', to: 'tableau-de-bord' },
          { text: 'Mon OFA', to: 'mon-ofa' },
          { text: 'Campagne', to: 'campagne' },
          { text: 'Mes archives', to: 'archives' },
        ]}
      />

      <div className={'px-12 py-6'} style={{ backgroundColor: '#F6F6F6' }}>
        <Outlet />
      </div>

      <ConsentBannerAndConsentManagement />
      <FcFooter appVersion={__APP_VERSION__} />
    </main>
  );
};